//  const URL = 'http://localhost:8000/api'
const URL = 'https://api.royalkarbala.com/api'
export default URL